const initSharing = button => {

    new Shariff(button, {
        orientation: 'horizontal',
        lang: socialSharing.language,
        url: socialSharing.pageUrl
    });
};


const socialSharingHandler = () => {

    const button = document.querySelector('.shariff');

    if(!button) {
        return;
    }

    initSharing(button);

    const networks = [
        {
            name: 'twitter',
            icon: 'fa-twitter'
        },
        {
            name: 'facebook',
            icon: 'fa-facebook-f'
        },
        {
            name: 'linkedin',
            icon: 'fa-linkedin-in'
        }
    ];

    for (const network of networks) {

        const items= document.querySelectorAll(`.shariff-button.${network.name} > a`);

        [...items].forEach(item => {
            item.innerHTML = socialSharing.icons[`${network.name}`];
        });


    }
};

export default socialSharingHandler;